/**
 * Клас для роботи з DOM
 * 
 * @package AGDS
 * @category Modules
 * @module Utils
 * @see AGDSApp
 * @author Andy Groove
 * @since 1.0.0
 */
export default class Utils {

	/**
	 * Конструктор
	 *
	 * @param {Object} options
	 */
	constructor(options = {}) {}

	/**
	 * Ініціалізація
	 */
	init() {}


	
}
